<template>
  <div>
    <my-menu menu-name="home"></my-menu>

    <div class="banner">
      <img class="bg" src="../assets/images/gzheader.png" />
      <div class="wrapper">
        <div class="switch">
          <router-link to="/" class="switch-active">教师端</router-link>
          <router-link to="/student" class="">学生端</router-link>
        </div>
        <div class="product_list">
          <div class="product_item">
<!--            <p class="text_weici">维词&bull;高中生</p>-->
<!--            <p class="text_slogan">自主学习词汇APP</p>-->
            <img style="width: 176px; display: inline-block" src="../assets/images/gzqrcodes.png" />
            <div class="product_des">
              <p>扫码下载</p>
              <p>维词学生版APP</p>
            </div>
          </div>
          <a href="https://bsource.weicistudy.com/pc_download/aistudent/weici-student.exe" target="_blank" class="product_item">
            <img src="../assets/images/pc.png"/>
            <div class="product_des">
              <p>点击下载</p>
              <p>维词数智化学生端</p>
<!--              <p>（MAC客户端）</p>-->
            </div>
          </a>
        </div>
<!--        <div class="download">-->
<!--          &lt;!&ndash;<router-link :to="{name: 'Download'}"><img src="../assets/images/ios.png" /></router-link>&ndash;&gt;-->
<!--          <a href="https://itunes.apple.com/cn/app/%E7%BB%B4%E8%AF%8D%E5%AD%A6%E7%94%9F%E7%89%88/id1354318292?mt=8" target="_blank">-->
<!--            <img src="../assets/images/ios.png" />-->
<!--          </a>-->
<!--          <div class="line"></div>-->
<!--          &lt;!&ndash;<router-link :to="{name: 'Download'}"><img src="../assets/images/ad.png" /></router-link>&ndash;&gt;-->
<!--          <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.android.weici.senior.student" target="_blank"><img src="../assets/images/ad.png" /></a>-->
<!--        </div>-->
      </div>
    </div>

    <section class="content">
      <div class="text">
        <p>维词app是一款专为高中生</p>
        <p>打造的英语学习软件</p>
        <p>让用户可以轻松的掌握高中英语知识</p>
        <p>Victor English Vocabulary APP is specially designed for high school students, </p>
        <p>
            to satisfy the needs for English studies and to master high school English knowledge and skills
        </p>
      </div>
      <div class="arrow">
        <img src="../assets/images/arrow.png" />
      </div>
      <div class="card">
        <ul>
          <li>
            <div class="card_text">
              <p class="title">学习资源丰富</p>
              <p class="title">内容精准</p>
              <p>5676个精讲词条，15979个例句音频</p>
              <p>大数据精选知识点，分层深度学习</p>
              <p>精彩发现区，让单词学习有趣、有效</p>
            </div>
            <div class="img_right">
              <img v-lazy="'/static/images/home/1.png'" />
            </div>
          </li>
          <li>
            <div class="img_left">
              <img v-lazy="'/static/images/home/2.png'" />
            </div>
            <div class="card_text right">
              <p class="title">同步课堂教学</p>
              <p class="title">融入学习各个场景</p>
              <p>同步教学进度、教材预习，课堂更轻松</p>
              <p>精选练习、作业、老师推荐，学习有的放矢</p>
              <p>词汇分级、话题学习，备考轻松</p>
            </div>
          </li>
          <li>
            <div class="card_text">
              <p class="title">练测题型多样</p>
              <p class="title">考察全面</p>
              <p>七大题型，覆盖单词学习核心要点</p>
              <p>错题自动收录，随时随地巩固</p>
              <p>告别枯燥刷题，学习过程更有趣</p>
            </div>
            <div class="img_right">
              <img v-lazy="'/static/images/home/3.png'" />
            </div>
          </li>
          <li>
            <div class="img_left">
              <img v-lazy="'/static/images/home/4.png'" />
            </div>
            <div class="card_text right">
              <p class="title">智能语音互动</p>
              <p class="title">听说能力提升快</p>
              <p>真人离线发音，提供精准语音输入</p>
              <p>单词例句跟读，告别“哑巴”英语</p>
              <p>错误发音即时纠正，英语学习更自信</p>
            </div>
          </li>
        </ul>
      </div>
       <!-- v-lazy:background-image="'../../../static/images/gzm2.png'" -->
<!--      <div class="ex_school">-->
<!--        <img v-lazy="'/static/images/gzm2.png'" style="width:100%;" />-->
<!--        <div class="ex_content">-->
<!--          <p>坚持21天培养英语学习好习惯</p>-->
<!--          <p>北京四中、衡水中学等百强名校都在用</p>-->
<!--          <p>A good habit of learning English will be developed if you use it only for 21 days!</p>-->
<!--          <p>Some Top 100 high schools in China such as Beijing No.4 High School and </p>-->
<!--          <p>Hengshui High School of Hebei have already taken the chance.</p>-->
<!--        </div>-->
<!--        <div class="clear"></div>-->
<!--      </div>-->
<!--      <div class="stu_list">-->
<!--        <ul>-->
<!--          <li>-->
<!--            <div class="thumb">-->
<!--              <img v-lazy="'/static/images/s2.png'" />-->
<!--              <div class="caption">-->
<!--                  <p>课堂作业，检测，错题本成了我日常学习的帮手，坚持使用维词学生版，英语学习真的轻松了不少。</p>-->
<!--                  <p style="text-align:right;font-size: 13px">山东青岛二中&nbsp;林婧怡</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </li>-->
<!--          <li>-->
<!--            <div class="thumb">-->
<!--              <img v-lazy="'/static/images/s1.png'" />-->
<!--              <div class="caption">-->
<!--                <p>单词例句离线发音，跟读打分，给我提供正确的语音输入，单词记忆效率更高了。</p>-->
<!--                <p style="text-align:right;font-size: 13px">河南科技大学附属中学&nbsp;程晨</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </li>-->
<!--          <li>-->
<!--            <div class="thumb">-->
<!--              <img v-lazy="'/static/images/s3.png'" />-->
<!--              <div class="caption">-->
<!--                <p>万词王挑战，单元闯关，告别了枯燥的单词记忆，而且记忆更深刻，强烈推荐。</p>-->
<!--                <p style="text-align:right;font-size: 13px">山东莱芜一中&nbsp;何桥</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </li>-->
<!--        </ul>-->
<!--        <div class="clear"></div>-->
<!--      </div>-->
    </section>

    <my-footer></my-footer>
  </div>
</template>

<script>
  import MyFooter from '@/components/Footer'
  import MyMenu from '@/components/Menu'

  export default {
    data () {
      return {
      }
    },
    components: {
      MyFooter,
      MyMenu
    },
    methods: {

    }
  }
</script>
<style scoped>
.product_list {
  margin-top: 150px;
  text-align: center;
}

.product_item {
  display: inline-block;
  font-size: 24px;
  color: #FFFFFF;
  margin-left: 30px;
}
.product_list .product_item .product_des p {
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// Index.vue?60bba3fc